import { Row, Col, Button, Input } from "antd";
import { useParams } from "react-router-dom";
import { ArrowLeftOutlined, ArrowRightOutlined, ReloadOutlined } from "@ant-design/icons";

import { useAppDispatch } from "app/hooks";
import useTPlusOneProcessing from "../hooks/useTPlusOneProcessing";
import {
  setIsRefreshStatusModalOpen,
  setIsPushToNIBSSModalOpen,
  setIsApproveBulkBatchModalOpen,
  setIsChangeBulkBatchApproverModalOpen,
} from "../tPlusOneProcessingSlice";

function TPlusOneProcessingBatchHeader() {
  const params = useParams();
  const dispatch = useAppDispatch();
  const { navigate, hasSelected, summaryBatch, selectedBatchRows, handleFilterChange } =
    useTPlusOneProcessing();

  return (
    <Row justify="space-between" style={{ padding: "15px 0px" }}>
      <Col>
        <Row gutter={6}>
          <Col>
            <Button
              size="large"
              shape="circle"
              onClick={() => navigate(-1)}
              icon={<ArrowLeftOutlined />}
            />
          </Col>
        </Row>
      </Col>

      <Col>
        <Row gutter={6}>
          <Col>
            <Button
              size="large"
              type="primary"
              disabled={!hasSelected}
              onClick={() => dispatch(setIsChangeBulkBatchApproverModalOpen(true))}
            >
              Update Selected Approver {hasSelected ? `(${selectedBatchRows.length})` : ""}
            </Button>
          </Col>

          <Col>
            <Button
              size="large"
              type="primary"
              disabled={!hasSelected}
              onClick={() => dispatch(setIsApproveBulkBatchModalOpen(true))}
            >
              Approve Selected {hasSelected ? `(${selectedBatchRows.length})` : ""}
            </Button>
          </Col>

          <Col>
            <Button
              size="large"
              icon={<ReloadOutlined />}
              disabled={!summaryBatch.data?.response.content.length}
              onClick={() => dispatch(setIsRefreshStatusModalOpen(true))}
            >
              Refresh Status
            </Button>
          </Col>

          <Col>
            {!(params && params?.batchId) ? (
              <Button
                size="large"
                icon={<ArrowRightOutlined />}
                disabled={!summaryBatch.data?.response.content.length}
                onClick={() => dispatch(setIsPushToNIBSSModalOpen(true))}
              >
                Push All to NIBSS
              </Button>
            ) : null}
          </Col>

          <Col>
            <Input.Search
              allowClear
              enterButton
              size="large"
              defaultValue=""
              addonBefore="BatchID"
              style={{ width: "auto" }}
              placeholder="Enter Batch ID"
              onSearch={(value) =>
                handleFilterChange("batchId", {
                  value: value,
                })
              }
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default TPlusOneProcessingBatchHeader;
